export const useModuleLabel = {
  TAGS: "type",
  LOCATION: "location",
  CALENDAR: "calendar",
  ORGANIZER: "organizer",
  CONTACT: "contact",
  REQUIRED: "required",
  TITLE: "title",
  OPTIONNEL: "optional",
  RECAP: "recap",
  CONFIRM: "confirm",
  SCHEDULE: "horaires",
  PRICE: "tarif",
  PAYING: "paying",
  CAPACITY: "capacity",
  RECURRENCE: "recurrence",
  INSIDE: "inside",
  SERVICES: "services",
  WEBSITE: "website",
  PHOTOS: "photos",
  VIDEO: "video",
  DESCRIPTION: "description",
  EXPOSANT: "exposant",
  EXHIBITOR_INFO: "informationsExposants", // Modalités d'inscription
  BOOKING_LINK: "bookingLink", // Lien d'inscription
  EXHIBITOR_FILE: "ficheInscription", // Bulletin d'inscription
  LOTO: "loto",
};
